// /LeadFlow/leadVisibilityFunction.js

export const calculateVisibleQuestions = (allQuestions, answers) => {
    if (!allQuestions || !allQuestions.length) return [];

    // Use question ID as the key for visibility and hidden status
    const finalVisibility = {};
    const explicitlyHidden = new Set(); // Stores IDs of questions explicitly hidden

    // 1. Initialize visibility using question ID
    allQuestions.forEach(q => {
        // finalVisibility maps question ID to its visibility status (boolean)
        finalVisibility[q.id] = q.conditional ? false : true;
    });

    // 2. Process answers for rules
    for (const [answeredQuestionId, answerValue] of Object.entries(answers)) {
        // Use String() to ensure safe comparison between object keys and numbers
        const sourceQuestion = allQuestions.find(q => String(q.id) === String(answeredQuestionId));
        
        if (!sourceQuestion || !sourceQuestion.conditional_logic || Object.keys(sourceQuestion.conditional_logic).length === 0) {
            continue;
        }

        const selectedValues = Array.isArray(answerValue) ? answerValue : (answerValue ? [answerValue] : []);

        for (const selectedOptValue of selectedValues) {
            // Find the Option Object to get its ID
            const matchedOption = sourceQuestion.options?.find(opt => String(opt.value) === String(selectedOptValue));
            
            if (!matchedOption) continue; // Skip if we can't find the option

            // Look up rules using the Option ID (cast to string to match JSON keys)
            const rules = sourceQuestion.conditional_logic[String(matchedOption.id)];
            
            if (rules && Array.isArray(rules)) {
                for (const rule of rules) {
                    const targetQuestionId = rule.question;
                    const targetQuestion = allQuestions.find(q => String(q.id) === String(targetQuestionId));

                    if (targetQuestion) {
                        // Ensure we only affect questions that come AFTER the trigger question
                        if (targetQuestion.order_index > sourceQuestion.order_index) {
                            if (rule.action === 'hide') {
                                explicitlyHidden.add(targetQuestion.id);
                                finalVisibility[targetQuestion.id] = false; // Hide always wins
                            } else if (rule.action === 'show') {
                                if (!explicitlyHidden.has(targetQuestion.id)) { // Apply show ONLY if not explicitly hidden
                                    finalVisibility[targetQuestion.id] = true;
                                }
                            }
                        } 
                    } 
                }
            }
        }
    }

    // 3. Filter questions based on the final visibility status
    const finalVisible = allQuestions.filter(q => finalVisibility[q.id]);

    return finalVisible;
};